import { useSelector } from 'react-redux';
// Use throughout your app instead of plain `useSelector`
export var useAppSelector = useSelector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/hooks/useAppSelector.js
// module id = 35
// module chunks = 11